import ActionButton from 'components/ActionButton';
import CustomLink from 'components/TableLink';
import { tableStyles } from 'css/tableStyles';
import React, { useEffect, useMemo, useState } from 'react';
import DataTable from 'components/DataTable';
import { useHistory } from 'react-router-dom';
import { fetchAllSubscriptionsForAdmin } from 'services/api/subscriptions';
import { DATE_FORMATS, formatDate, showError } from 'utils';
import styles from './index.module.scss';

const Subscriptions = (props) => {
  const history = useHistory();
  const { stripeProductId = '' } = props;
  const [subscriptions, setSubscriptions] = useState([]);

  const fetchAllSubscriptionsFn = async () => {
    try {
      const response = await fetchAllSubscriptionsForAdmin({
        filters: { productId: stripeProductId },
      });
      setSubscriptions(response);
    } catch (e) {
      showError(e);
    }
  };

  useEffect(() => {
    fetchAllSubscriptionsFn();
  }, []);

  const columns = useMemo(
    () => [
      {
        name: 'Id',
        selector: 'objectId',
        cell: (row) => (
          <CustomLink
            text={row.objectId}
            linkTo={`/subscription/${row.objectId}`}
          />
        ),
      },
      {
        name: 'Name',
        selector: 'name',
      },
      {
        name: 'Price($)',
        selector: 'price',
        format: (row) => row?.price / 100,
      },
      {
        name: 'Stripe price id',
        selector: 'priceId',
      },
      {
        name: 'Type',
        selector: 'type',
      },
      {
        name: 'Created At',
        selector: 'createdAt',
        format: (row) => formatDate(row.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A),
      },
    ], [],
  );

  const getHeader = () => {
    return (
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>Subscriptions</div>
        <ActionButton
          active={true}
          isLoading={false}
          onClick={() => {history.push(`/subscription/create?stripeProductId=${stripeProductId}`)}}
          text={
            <>
              Subscriptions <span className={'ml-3'}>+</span>
            </>
          }
        />
      </div>
    );
  };

  return (
    <div className={styles['subscriptions-container']}>
      {getHeader()}
      <DataTable
        noHeader
        data={subscriptions}
        columns={columns}
        customStyles={tableStyles}
      />
    </div>
  );
};

export default Subscriptions;
